// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "svg.button-stop[data-v-2b937188]{color:#dc3545}", ""]);
// Exports
module.exports = exports;
